import React, { useContext, useState } from 'react';
import {
  string, oneOfType, arrayOf, node
} from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  Accordion,
  AccordionHeader
} from '@one-thd/sui-atomic-components';
import { Drawer, DrawerItem, DrawerPosition, DrawerHeader } from '@thd-olt-component-react/drawer';
import { MOBILE } from '@thd-olt-functional/utils';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { RatingsAndReview } from './RatingsAndReview';
import { ServiceReviewContextProvider } from './ServiceReviewContext';

export const ServiceReview = ({ serviceIdentifier, title, children }) => {
  const [isServiceReviewsOpen, setIsServiceReviewsOpen] = useState(false);

  const openDrawer = (event) => {
    event.preventDefault();
    setIsServiceReviewsOpen(true);
  };

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === MOBILE;
  const drawerMaxSize = isMobile ? 100 : 500;

  return (
    <ServiceReviewContextProvider value={{
      ctaSection: children
    }}
    >
      <div onClick={openDrawer} role="button" tabIndex={0} data-testid="bttn-service-reviews">
        <Accordion id="service-reviews" expanded={false}>
          <AccordionHeader>
            {title}
          </AccordionHeader>
        </Accordion>
      </div>
      <Drawer
        open={isServiceReviewsOpen}
        onClose={() => setIsServiceReviewsOpen(false)}
        initialItem="service-reviews"
        position={DrawerPosition.RIGHT}
        maxSize={drawerMaxSize}
        isMobile={isMobile}
      >
        <DrawerItem name="service-reviews">
          <DrawerHeader name="drawer-nav" title={title} />
          <QueryProvider cacheKey="service-reviews">
            <RatingsAndReview
              serviceIdentifier={serviceIdentifier}
              isDrawerOpen={isServiceReviewsOpen}
            />
          </QueryProvider>
        </DrawerItem>
      </Drawer>
    </ServiceReviewContextProvider>
  );
};

ServiceReview.displayName = 'ServiceReview';

ServiceReview.propTypes = {
  title: string,
  serviceIdentifier: string.isRequired,
  children: oneOfType([
    arrayOf(node),
    node
  ])
};

ServiceReview.defaultProps = {
  title: 'Service Reviews',
  children: <span />
};